import { render } from "./RecentEarningsChart.vue?vue&type=template&id=a06ae11c&ts=true"
import script from "./RecentEarningsChart.vue?vue&type=script&lang=ts"
export * from "./RecentEarningsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__